import { createAlgoliaClient } from '@/helpers/algolia/algoliaV5';
import { buildAlgoliaObjectIdFilter, type RecommendSourceProduct } from '@/helpers/utils/similarItemsQueryParameters';

export const fetchAlgoliaSourceProductForRecommend = async ({
  appId,
  apiKey,
  indexName,
  objectId,
  attributesToRetrieve,
}: {
  appId: string;
  apiKey: string;
  indexName: string;
  objectId: string;
  attributesToRetrieve: string[];
}): Promise<RecommendSourceProduct | undefined> => {
  const searchClient = createAlgoliaClient(appId, apiKey);
  const { hits } = await searchClient.searchSingleIndex({
    indexName,
    searchParams: {
      query: '',
      filters: buildAlgoliaObjectIdFilter(objectId),
      hitsPerPage: 1,
      attributesToRetrieve,
    },
  });

  return hits[0] as RecommendSourceProduct | undefined;
};
